import { render, staticRenderFns } from "./public-holidays-calendar.vue?vue&type=template&id=6473f8fe"
import script from "./public-holidays-calendar.vue?vue&type=script&lang=js"
export * from "./public-holidays-calendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports